export enum JOB_ACTION {
    FORCE_FAIL = 'job-force-failed',
    CLONE = 'job-clone',
}
